'use client';
import { resolveDisplayKeys } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/keybindingDisplay.js';
import { useShortcutRegistry } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/registry.js';
import { getShortcutDefinition, isShortcutVisibleOnCurrentDevice, } from '#pplx/frontend/apps/ask/keyboard-shortcuts-provider/shortcutManifest.js';
import { useKeyboardHintStyle } from '#pplx/frontend/apps/ask/user-settings/hooks/useKeyboardHintStyle.js';
import { useCallback, useMemo, useSyncExternalStore } from 'react';
/**
 * Returns display-friendly keys for the highest-priority active registration.
 *
 * Returns `undefined` when the shortcut is not registered, the matching
 * registration is disabled, or the current device should not show shortcut UI.
 * For shortcuts with multiple keybindings, only the first keybinding is rendered
 * to match {@link resolveDisplayKeys}.
 */
export function useRegisteredShortcutDisplay(id) {
    const style = useKeyboardHintStyle();
    const { subscribe, getDisplayKeybinding, isMobileDevice } = useShortcutRegistry();
    const getSnapshot = useCallback(() => getDisplayKeybinding(id), [getDisplayKeybinding, id]);
    const keybinding = useSyncExternalStore(subscribe, getSnapshot, () => undefined);
    return useMemo(() => {
        const definition = getShortcutDefinition(id);
        if (!isShortcutVisibleOnCurrentDevice(definition, isMobileDevice)) {
            return undefined;
        }
        return keybinding === undefined ? undefined : resolveDisplayKeys([keybinding], style);
    }, [keybinding, id, isMobileDevice, style]);
}
//# sourceMappingURL=useRegisteredShortcutDisplay.js.map